import {
  GroupsManagerEnrollmentsOrderByFieldsEnum,
  GroupsManagerEnrollmentsSearchableFieldsEnum,
  GroupsManagerGroupChangesOrderByFieldsEnum,
  GroupsManagerGroupChangesSearchableFieldsEnum,
  GroupsManagerSearchOrderByFields,
  GroupsManagerSearchSearchableFieldsEnum,
  OrderByDirection,
} from "@models/ISchema";
import { create } from "zustand";
import {
  EnrollmentsTableColumn,
  GroupsChangesTableColumn,
  GroupsManagerTableColumn,
  SubGroupsTableColumn,
} from "../models";

export interface GroupsTableFiltersState {
  columnsToHide: Set<
    | GroupsManagerTableColumn
    | GroupsChangesTableColumn
    | SubGroupsTableColumn
    | EnrollmentsTableColumn
  >;
  orderBy: {
    header:
      | GroupsManagerTableColumn
      | GroupsChangesTableColumn
      | SubGroupsTableColumn
      | EnrollmentsTableColumn;
    field:
      | GroupsManagerSearchOrderByFields
      | GroupsManagerGroupChangesOrderByFieldsEnum
      | GroupsManagerEnrollmentsOrderByFieldsEnum;
    direction: OrderByDirection;
  };
  searchBy: {
    text: string;
    fields:
      | GroupsManagerSearchSearchableFieldsEnum[]
      | GroupsManagerGroupChangesSearchableFieldsEnum[]
      | GroupsManagerEnrollmentsSearchableFieldsEnum[];
  };
}

const createInitialFilters = (): GroupsTableFiltersState => ({
  columnsToHide: new Set(),
  orderBy: { header: null, field: null, direction: null },
  searchBy: { text: "", fields: [] },
});

export const useGroupsTableFilters = create<GroupsTableFiltersState>(() => createInitialFilters());

export const replaceTableFilters = (filters: GroupsTableFiltersState) =>
  useGroupsTableFilters.setState({
    columnsToHide: new Set(filters.columnsToHide),
    orderBy: { ...filters.orderBy },
    searchBy: { ...filters.searchBy, fields: filters.searchBy.fields.slice() },
  });

export const setTableFiltersColumnsToHide = (
  columnsToHide: GroupsTableFiltersState["columnsToHide"],
) => useGroupsTableFilters.setState({ columnsToHide: new Set(columnsToHide) });

export const setTableFiltersOrderBy = (orderBy: GroupsTableFiltersState["orderBy"]) =>
  useGroupsTableFilters.setState({ orderBy: { ...orderBy } });

export const setTableFiltersSearchBy = (searchBy: GroupsTableFiltersState["searchBy"]) =>
  useGroupsTableFilters.setState({ searchBy: { ...searchBy, fields: searchBy.fields.slice() } });

export const setTableFiltersSearchByFields = (
  fields: GroupsTableFiltersState["searchBy"]["fields"],
) =>
  useGroupsTableFilters.setState(state => ({
    searchBy: { ...state.searchBy, fields: fields.slice() },
  }));

export const setTableFiltersSearchByText = (text: string) =>
  useGroupsTableFilters.setState(state => ({ searchBy: { ...state.searchBy, text } }));

export const resetTableFilters = () => useGroupsTableFilters.setState(createInitialFilters());
